import { render, staticRenderFns } from "./DetailContactSubject.vue?vue&type=template&id=2c861172&scoped=true"
import script from "./DetailContactSubject.vue?vue&type=script&lang=js"
export * from "./DetailContactSubject.vue?vue&type=script&lang=js"
import style0 from "./DetailContactSubject.vue?vue&type=style&index=0&id=2c861172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c861172",
  null
  
)

export default component.exports